module.exports = __webpack_public_path__ + "img/2434992be17ecf287c8057565a994db3.png";